"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeParentMenuAfterClick = void 0;
const index_1 = require("../index");
const closeParentMenuAfterClick = () => {
    const menuCheckBox = document.getElementById(`${index_1.className}__checkbox`);
    const { type } = menuCheckBox || {};
    if (menuCheckBox && type === 'checkbox') {
        menuCheckBox.checked = false;
    }
    return false;
};
exports.closeParentMenuAfterClick = closeParentMenuAfterClick;
//# sourceMappingURL=index.js.map